import menu from './de/menu'
import home from './de/home'
import title from './de/title'
import profile from './de/profile'
import burial from './de/burial'
import ceremony from './de/ceremony'
import guestlist from './de/guestlist'
import contacts from './de/contacts'
import pets from './de/pets'
import footer from './de/footer'
import login from './de/login'
import signup from './de/signup'
import recover from './de/recover'
import guardian from './de/guardian'
import guardians from './de/guardians'
import documents from './de/documents'
import proteges from './de/proteges'
import invitations from './de/invitations'
import addGuardian from './de/add-guardian'
import protegeAllInfo from './de/protege-all-info'
import account from './de/account'
import links from './de/links'
import speeches from './de/speeches'
import disclaimer from './de/disclaimer'
import imprint from './de/imprint'
import jumbotron from './de/jumbotron'
import photos from './de/photos'
import feedback from './de/feedback'
import videos from './de/videos'
import general from './de/general'
import print from './de/print'

const de = {
    menu,
    home,
    title,
    profile,
    burial,
    ceremony,
    guestlist,
    contacts,
    pets,
    footer,
    login,
    signup,
    recover,
    guardian,
    guardians,
    documents,
    proteges,
    invitations,
    addGuardian,
    protegeAllInfo,
    account,
    links,
    speeches,
    disclaimer,
    imprint,
    jumbotron,
    photos,
    feedback,
    videos,
    general,
    print
}

export default de



// WEBPACK FOOTER //
// ./src/assets/i18n/lang/de.js